import React from 'react';

const Religion = () => {
  return (
    <div style={{
      minHeight: '60vh',
      background: 'linear-gradient(135deg, #fdf2f8 0%, #fbecf8 100%)',
      padding: '2rem 1rem',
    }}>
      <div className="page-wrapper">
        <div className="page-hero">
          <h1>🙏 Religion & Spirituality</h1>
          <p>Explore spiritual wisdom and religious teachings.</p>
        </div>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '2rem',
        }}>
          <p>Religion content will be rendered here</p>
        </div>
      </div>
    </div>
  );
};

export default Religion;
